exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main,.scroll-hidden{min-height:100vh}.scroll-hidden{overflow:hidden;height:100vh}#template_header{background-color:#535768}#template_header img{width:100px;max-width:100%}.template_sample_body{padding-top:11vh;margin-top:-11vh;min-height:80vh}.template_sub_menu{text-align:right}.template_input{background-color:#f4efef;width:150px;max-width:90%;padding:5px;min-height:35px}.template_input_border{border:none;border-radius:4px;box-shadow:inset 0 0 10px hsla(0,1%,41%,.493)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/assets/scss/templatepages.scss
// module id = 1164
// module chunks = 2